/**
 * Anonymous, browser-local player identity.
 *
 * One UUID is generated lazily on first call, persisted in localStorage,
 * and reused for every subsequent request. Players can clear it by clearing
 * site data; we make no attempt to fingerprint or recover the prior id.
 *
 * Display name is independent and only matters when the player joins a
 * friend group — see Group.js for the join flow.
 */

const PLAYER_ID_KEY    = 'langle.playerId';
const DISPLAY_NAME_KEY = 'langle.displayName';

function makeUuid() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback for older browsers — good enough as an anonymous handle.
  return 'p-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function getPlayerId() {
  try {
    let id = localStorage.getItem(PLAYER_ID_KEY);
    if (!id) {
      id = makeUuid();
      localStorage.setItem(PLAYER_ID_KEY, id);
    }
    return id;
  } catch {
    // localStorage disabled (private window, etc.) — generate a session-only
    // id so the rest of the app still works for the current page load.
    return makeUuid();
  }
}

export function getDisplayName() {
  try { return localStorage.getItem(DISPLAY_NAME_KEY) || ''; }
  catch { return ''; }
}

export function setDisplayName(name) {
  try { localStorage.setItem(DISPLAY_NAME_KEY, (name || '').trim()); } catch {}
}
